<template lang="pug">
    div
        Poptip(width="750" transfer v-model="visible")
            Button(shape="circle" icon="md-help" size="small")
            template(slot="title")
                p How to decrypt signed URL on your origin server?
            template(slot="content")
                p We use AES-128-CBC and MD5 encryption, then convert the result to a hexadecimal string.
                p You can follow the examples below to decrypt on your server.
                    Collapse(id="collapse")
                        template(v-for="panel in panels")
                            Panel(:name="panel.name") {{panel.name}}
                                pre(slot="content") {{panel.command}}
</template>
<script>
export default {
    name: "ExplainHotlink",
    data() {
        return {
            visible: false,
            panels: [
                {
                    name: "Node.js",
                    command: `// crypt.js
const crypto = require("crypto");
const algorithm = "AES-128-CBC";

const encrypt = (text, key) => {
    const cipher = crypto.createCipher(algorithm, key);
    const encrypted = cipher.update(text, "utf8", "hex") + cipher.final("hex");
    return encrypted;
};

module.exports = { encrypt };

// app.js
const express = require("express");
const app = express();
const port = 3001;
const crypt = require("./crypt");

const htmlContent = ({ wafHotlinkQueryArgument, wafHotlinkQueryValue }) =>
    "<h2>Hello World</h2>" +
    '<img src="./img/your_image.png?' +
    wafHotlinkQueryArgument +
    "=" +
    wafHotlinkQueryValue +
    '"/>';

app.get("/", (req, res) => {
    // 防盜鏈 URL 參數名稱 (KEY)
    const wafHotlinkQueryArgument = "key";
    // 時間戳
    const timestamp = (new Date().getTime() / 1000).toString();
    // 防盜鏈金鑰
    const wafHotlinkSecretKey = "abc";
    // 防盜鏈 URL 的值 (VALUE)
    const wafHotlinkQueryValue = crypt.encrypt(timestamp, wafHotlinkSecretKey);

    res.send(htmlContent({ wafHotlinkQueryArgument, wafHotlinkQueryValue }));
});

app.listen(port, () => {
    console.log("Example App Listening on Port" + port);
});
`,
                },
                {
                    name: "nginx",
                    command: `location ~ /your_uri_path {
    content_by_lua_block {
        local aes = require "resty.aes"
        local str = require "resty.string"

        local function data_encrypt(cus_key, cus_data)
            local aes_128_cbc_md5 = aes:new(cus_key)
            local encrypted = aes_128_cbc_md5:encrypt(cus_data)
            local secret_word = str.to_hex(encrypted)
            return secret_word
        end
        local waf_hotlink_secret_key = "abc"
        local waf_hotlink_signed_uri = data_encrypt(waf_hotlink_secret_key, tostring(ngx.now()))
        local waf_hotlink_query_argument = "key"

        local html = {
            [1] = [[
                <h2>Hello World</h2>
                <img src="/img/your_image.png?]],
            [2] = waf_hotlink_query_argument,
            [3] = '=',
            [4] = waf_hotlink_signed_uri,
            [5] = '"/>'
        }
        html = table.concat(html, "")

        ngx.header.content_type = 'text/html'
        ngx.say(html)
    }
}

location /your_image.png {
        root /path/to/images/;
        try_files $uri =404;
}`,
                },
            ],
        };
    },
};
</script>



// WEBPACK FOOTER //
// src/components/PoptipInfos/ExplainHotlink.vue